const list = {
    or: 'veya',
    and: 've',
    separator: ',',
};
export default Object.freeze(list);
